import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import EirInformation from '../../eir-information/EirInformation';
import FaqContainer from '../../eir-mobile-broadband/FaqContainer';
import useStyles from './styles';
import EirDeviceContainer from '../../eir-device-list/EirDeviceContainer';
import { PrepayOfferContext } from '../prepay-mobile/prepay.context';
import { onLoadPrepayHandset } from './handsets.util';
import RootContext from '../../../../util/root.context';
import ApiFailureModal from '../../eir-error-modal/ApiFailureModal';
import ErrorModal from '../../eir-error-modal/ErrorModal';
import { useToggle } from '../../../hooks/useToggle';
import { getCookie } from '../../../hooks/useCookie';

/**
 * @name PrepayHandsetsContainer - PrepayHandsetsContainer component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns Prepay Handsets Container Element
 */
const PrepayHandsetsContainer = ({ cmsData = {} }) => {
  const theme = useTheme();
  const style = useStyles(theme);
  const [state, setState] = useState({
    devices: [],
    brands: [],
    prepayPhone: true,
  });
  const [loader, setLoader] = useState(true);
  const { state: rootState, dispatch } = useContext(RootContext);
  const graphql = useApolloClient();
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const openAPIFailureModal = useToggle(false);
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const errorModalMaxOccurence = 2;
  const errorModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);

  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  const onPageLoad = async () => {
    onLoadPrepayHandset({
      graphql,
      setState,
      setLoader,
      state,
      setOnLoadError,
      setErrorModalOccurence,
      setOpenError,
      openAPIFailureModal,
      errorModalOccurence,
      errorModal,
      rootState,
      dispatch,
    });
  };
  useEffect(() => {
    onPageLoad();
  }, []);

  return (
    <PrepayOfferContext.Provider value={{ state, setState }}>
      <Grid container spacing={2}>
        <EirInformation
          title={cmsData?.attributes?.eirInformationHandsets?.title}
          description={cmsData?.attributes?.eirInformationHandsets?.description}
          textAlign={cmsData?.attributes?.eirInformationHandsets?.textAlign}
          useH1={cmsData?.attributes?.eirInformationHandsets?.useH1}
          style={{
            description: { pb: getCookie('STANDALONE_HANDSET') === 'true' ? 0 : 4 },
          }}
        />
        <Grid container justifyContent='center'>
          {state?.devices && (
            <Grid item xs={12}>
              <EirDeviceContainer
                devices={state?.devices}
                brands={state?.brands}
                loading={loader}
                cmsData={cmsData?.data}
                isPrepayHandset
              />
            </Grid>
          )}
        </Grid>
        {cmsData?.attributes?.handsetsFaqList?.length > 0 && (
          <Grid item xs={12} sx={style.faqContainerSuperMain}>
            <FaqContainer
              InsuranceHeading={cmsData?.attributes?.handsetsFaqTitle}
              InsuranceList={cmsData?.attributes?.handsetsFaqList}
            />
          </Grid>
        )}
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onLoadError ? onPageLoad : () => {}}
          />
        )}
      </Grid>
    </PrepayOfferContext.Provider>
  );
};

PrepayHandsetsContainer.displayName = 'PrepayHandsetsContainer';
export default PrepayHandsetsContainer;
